import styled, { css } from 'styled-components';

import { breakpoints } from '#src/style/mediaQuery.ts';

export const Container = styled.div<{ maxWidth?: number }>`
  display: grid;
  --container-padding: var(--double-unit);
  --container-width: min(
    ${({ maxWidth }) => maxWidth ?? breakpoints.desktop}px,
    calc(100% - 2 * var(--container-padding))
  );
  grid-template-columns:
    1fr
    var(--container-width)
    1fr;
  & > * {
    grid-column: 2;
  }
`;

export const fullWidthStyles = css`
  width: 100%;
  grid-column: 1 / 4;
`;

export const FullWidth = styled.div`
  ${fullWidthStyles}
`;

export const SmallContainer = styled(Container)`
  grid-template-columns:
    1fr
    min(${breakpoints.tablet}px, calc(100% - 2 * var(--container-padding)))
    1fr;
`;
